import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Layout/AuthLayout.vue';

import NotFound from '@/views/NotFoundPage.vue';
import DB from '../util/DB';

const APP_THEME = process.env.VUE_APP_THEME;

const routes = [
  {
    path: '/',
    redirect: 'edit-profile',
    component: DashboardLayout,
    children: [
      {
        path: '/suspend',
        name: 'suspend',
        component: () => import('../views/Suspend.vue')
      },
      {
        path: '/kyc',
        name: 'kyc',
        component: () => import('../views/Kyc.vue')
      },
      {
        path: '/kyc-summary',
        name: 'kyc-summary',
        component: () => import('../views/KycSummary.vue')
      },
      {
        path: '/choose-card',
        name: 'choose-card',
        component: () => import(`../views/New-Deposit/${APP_THEME}/ChooseCard.vue`)
      },
      {
        path: '/deposit-method',
        name: 'deposit-method',
        props: route => ({
          card_number: route.query.card_number
        }),
        component: () => import(`../views/New-Deposit/${APP_THEME}/DepositMethod.vue`)
      },
      {
        path: '/digital-assets',
        name: 'digital-assets',
        props: route => ({
          card_number: route.query.card_number,
          network: route.query.network
        }),
        component: () => import(`../views/New-Deposit/${APP_THEME}/DigitalAssets.vue`)
      },
      {
        path: '/change-pin',
        name: 'change-pin',
        props: route => ({
          id: route.query.id,
          account_id: route.query.account_id
        }),
        component: () => import('../views/ChangePin.vue')
      },
      {
        path: '/request-change-pin',
        name: 'request-change-pin',
        props: route => ({
          id: route.query.id,
          account_id: route.query.account_id
        }),
        component: () => import('../views/RequestChangePIN.vue')
      },
      {
        path: '/card-lock',
        name: 'card-lock',
        props: route => ({
          id: route.query.id
        }),
        component: () => import('../views/CardLock.vue')
      },
      {
        path: '/card-cancel',
        name: 'card-cancel',
        props: route => ({
          id: route.query.id
        }),
        component: () => import('../views/CardCancel.vue')
      },
      {
        path: '/card-management',
        name: 'card-management',
        component: () => import('../views/New-Card-Management/zero.vue')
      },
      {
        path: '/order-card',
        name: 'order-card',
        component: () => import('../views/New-Card-Management/OrderCard.vue')
      },
      {
        path: '/fill-in-details',
        name: 'fill-in-details',
        component: () => import('../views/New-Card-Management/ApplyInfo.vue'),
      },
      {
        path: '/shipment-method',
        name: 'shipment-method',
        component: () => import('../views/New-Card-Management/ShipmentMethod.vue')
      },
      {
        path: '/payment-summary',
        name: 'payment-summary',
        component: () => import('../views/New-Card-Management/PaymentSummary.vue')
      },
      {
        path: '/payment-method',
        name: 'payment-method',
        component: () => import('../views/New-Card-Management/PaymentMethod.vue')
      },
      {
        path: '/application-fee',
        name: 'application-fee',
        component: () => import(`../views/New-Card-Management/${APP_THEME}/ApplicationFee.vue`)
      },
      {
        path: '/transfer',
        name: 'transfer',
        component: () => import('../views/Transfer/transfer.vue')
      },
      {
        path: '/deposit-details',
        name: 'deposit-details',
        props: route => ({
          trans_no: route.query.trans_no
        }),
        component: () => import('../views/New-Deposit/depositDetails.vue')
      },
      {
        path: '/edit-profile',
        name: 'edit-profile',
        component: () => import('../views/EditProfile.vue')
      },
      {
        path: '/system-configuration',
        name: 'system-configuration',
        component: () => import('../views/Settings/SystemConfiguration.vue')
      },
      {
        path: '/change-password',
        name: 'change-password',
        component: () => import('../views/Settings/ChangePassword.vue')
      },
      {
        path: '/deposit-report',
        name: 'deposit-report',
        component: () => import('../views/DepositReport.vue')
      },
      {
        path: '/transaction',
        name: 'transaction',
        component: () => import('../views/Transaction/TransactionReport.vue')
      },
      {
        path: '/cs',
        name: 'customer-service',
        component: () => import('../views/CustomerService.vue')
      },
      {
        path: '/faq',
        name: 'faq',
        component: () => import('../views/Faq.vue')
      },
      {
        path: "/logout",
        name: "logout",
        component: {
          async beforeRouteEnter(to, from, next) {
            localStorage.removeItem("token");
            localStorage.removeItem("member");
            localStorage.removeItem("isFirstTime");

            await DB.clear(); // tambahkan ini
            location.reload();
          }
        }
      }
    ]
  },
  {
    path: '/',
    redirect: 'login',
    component: AuthLayout,
    children: [
      {
        path: '/login',
        name: 'login',
        meta: {
          noBodyBackground: true
        },
        props: route => ({
          token: route.query.verification,
          register: route.query.register
        }),
        component: () => import('../views/Auth/Login.vue')
      },
      {
        path: '/register',
        name: 'register',
        meta: {
          noBodyBackground: true
        },
        component: () => import('../views/Auth/Register.vue')
      },
      {
        path: '/forgot-password',
        name: 'forgot-password',
        meta: {
          noBodyBackground: true
        },
        component: () => import('../views/Auth/ForgotPassword.vue')
      },
      {
        path: '/resend-email',
        name: 'resend-email',
        meta: {
          noBodyBackground: true
        },
        component: () => import('../views/Auth/ResendEmail.vue')
      },
      {
        path: '/term-condition',
        name: 'term-condition',
        meta: {
          noBodyBackground: true
        },
        component: () => import('../views/TermCondition.vue')
      },
      {
        path: '/privacy-policy',
        name: 'privacy-policy',
        meta: {
          noBodyBackground: true
        },
        component: () => import(`../views/PrivacyPolicy/${APP_THEME}/PrivacyPolicy.vue`)
      },
      {
        path: '/payment',
        name: 'payment',
        meta: {
          noBodyBackground: true
        },
        component: () => import('../views/PendingPayment.vue')
      },
      { path: '*', component: NotFound },
    ]
  }
];

export default routes;
